import { Post } from '../../../types/models';
import { getTranslatedBlogContent } from './blogTranslations';

export const blogPosts: Post[] = [
  {
    id: 1,
    title: "Maintenance industrielle : solutions pratiques pour une production continue et performante",
    slug: "maintenance",
    content: `
      <section>
        <h2>Maintenance industrielle : solutions pratiques pour une production continue et performante</h2>
        <p>
        La maintenance industrielle regroupe l'ensemble des actions visant à assurer le bon fonctionnement des machines et équipements. Elle permet de prévenir les pannes, d’optimiser la production et de réduire les coûts.       
         </p>
      </section>

      <section>
        <h2>Pourquoi la maintenance industrielle est-elle importante ?</h2>
        <p>Sans maintenance efficace : </p>
        <ul>
          <li> Les pannes augmentent</li>
          <li>La production s'arrête</li>
          <li>Les coûts explosent</li>
        </ul>
      </section>
      <section>
        <h2>Comment éviter les pannes dans une entreprise ?</h2>
        <p>Pour limiter les pannes, il faut : </p>
        <ul>
          <li>Mettre en place une maintenance préventive</li>
          <li>Surveiller régulièrement les équipements</li>
          <li>Remplacer les pièces usées à temps</li>
        </ul>
      </section>
       <section>
        <h2>Quels sont les types de maintenance industrielle ?</h2>
        <p>Il existe 3 types principaux : </p>
        <ul>
          <li>Maintenance corrective : réparer après une panne</li>
          <li>Maintenance préventive : anticiper les problèmes</li>
          <li>Maintenance prédictive : utiliser les données pour prévoir les pannes</li>
        </ul>
      </section>
      <section>
        <h2>Comment améliorer la maintenance industrielle dans une entreprise ?</h2>
        <p>Pour améliorer la maintenance industrielle, il est essentiel de : </p>
        <ul>
          <li>Mettre en place une maintenance préventive</li>
          <li>Utiliser un logiciel de gestion (GMAO)</li>
          <li>Former les équipes techniques</li>
          <li>Analyser les pannes régulièrement</li>
        </ul>
      </section>
      <section>
        <h2>Pourquoi l'utilisation d'une GMAO est très importante ?</h2>
        <p>Une GMAO permet de : </p>
        <ul>
          <li>Planifier les interventions</li>
          <li>Suivre les équipements</li>
          <li>Analyser les performances</li>
        </ul>
      </section>
 <section>
        <p>
         Optimisez votre production et réduisez les arrêts grâce à nos solutions de maintenance industrielle : contactez
          <a href="https://www.a2s-sarl.com" target="_blank" rel="noopener noreferrer">www.a2s-sarl.com</a>
          dès maintenant pour un accompagnement sur mesure.
        </p>
      </section>
      
    `,
    excerpt: "Prévenez les pannes, optimisez la production et réduisez les coûts grâce à une maintenance industrielle efficace.",
    featuredImage: "/images/blog/maintenance-industrielle.webp",
    status: "published",
    authorId: 1,
    createdAt: "2024-01-10T10:00:00Z",
    updatedAt: "2024-01-10T10:00:00Z",
  },

  {
    id: 2,
    title: "Traitement des eaux usées et assainissement : méthodes et solutions efficaces",
    slug: "water-treatment",
    content: `
      <section>
        <h2>Traitement des eaux usées et assainissement</h2>
        <p>
          Le traitement des eaux usées consiste à éliminer les polluants présents dans l'eau utilisée par les ménages, les industries et les entreprises avant son rejet ou sa réutilisation.
        </p>
      </section>

      <section>
        <h2>Pourquoi l'assainissement est-il important ?</h2>
        <p>L'assainissement permet de : </p>
        <ul>
          <li>Protéger la santé des populations</li>
          <li>Éviter la pollution des rivières et des sols</li>
          <li>Préserver les ressources en eau potable</li>
        </ul>
      </section>

      <section>
        <h2>Quelles sont les étapes du traitement des eaux usées ?</h2>
        <p>Le traitement se fait généralement en plusieurs étapes : </p>
        <ul>
          <li>Prétraitement : élimination des déchets solides (plastiques, sable.)</li>
          <li>Traitement primaire : séparation des matières en suspension</li>
          <li>Traitement secondaire : dégradation des matières organiques par des bactéries</li>
          <li>Traitement tertiaire : purification avancée de l'eau</li>
        </ul>

      </section>

      <section>
        <h2>Quelles sont les méthodes de traitement des eaux usées ?</h2>
        <p>On distingue plusieurs méthodes principales : </p>
        <ul>
          <li>Méthodes physiques : filtration, décantation</li>
          <li>Méthodes biologiques : utilisation de micro-organismes</li>
          <li>Méthodes chimiques : désinfection, traitement au chlore ou à l'ozone</li>
        </ul>

      </section>

      <section>
        <h2>Comment fonctionne une station d'épuration ?</h2>

        <p>
          Une station d'épuration est une installation qui regroupe toutes les étapes du traitement des eaux usées.
          Elle permet de transformer l'eau polluée en eau plus propre avant son rejet dans la nature.
        </p>

      </section>

      <section>
        <h2>Quels sont les types d'assainissement ?</h2>
        <p>Il existe deus types principaux : </p>
        <ul>
          <li>Assainissement collectif : réseau public relié à une station d'épuration</li>
          <li>Assainissement autonome : installations individuelles comme les fosses septiques</li>
        </ul>

      </section>

      <section>
        <h2>Quelles sont les solutions modernes ?</h2>
        <p>Aujourd'hui,plusieurs solutions innovantes sont utilisées : </p>
        <ul>
          <li>Recyclage des eaux usées traitées</li>
          <li>Technologies écologiques de purification</li>
          <li>Systèmes intelligents de gestion de l'eau</li>
          <li>Réduction de la consommation d'eau</li>
        </ul>
      </section>
      </section>
    `,
    excerpt: "Découvrez les étapes du traitement des eaux usées et les solutions modernes pour protéger la santé et l'environnement.",
    featuredImage: "/images/blog/traitement-des-eaux-et-assainissement.jpeg",
    status: "published",
    authorId: 1,
    createdAt: "2024-02-01T10:00:00Z",
    updatedAt: "2024-02-01T10:00:00Z",
  },

  {
    id: 3,
    title: "Comment choisir les équipements de piscines ? Guide complet",
    slug: "pools",
    content: `
      <section>
        <h2>Comment choisir les équipements de piscines ? </h2>
        <p>
          Quels équipements sont indispensables pour une piscine ? Comment bien les choisir pour garantir confort, sécurité et durabilité ?
          Que ce soit pour une piscine privée ou publique, le choix des équipements est essentiel pour assurer un bon fonctionnement et une utilisation optimale.Voici un guide complet pour vous aider.
        </p>
      </section>

      <section>
        <h2>Quels sont les équipements essentiels d'une piscine ?</h2>
        <p>Une piscine bien équipée comprend géenéralement : </p>
        <ul>
          <li>Système de filtration (pompe et filtre)</li>
          <li>Skimmers et buses de refoulement</li>
          <li>Échelle ou escalier d'accès</li>
          <li>Éclairage de piscine</li>
          <li>Système de traitement de l'eau (chlore, sel, UV)</li>
          <li>Accessoires de nettoyage (balai, robot)</li>
        </ul>
      </section>

      <section>
        <h2>Comment choisir un système de filtration ?</h2>
        <p>Le système de filtration est l'élément le plus important.Pour bien le choisir : </p>
        <ul>
          <li>Adapter la puissance à la taille de la piscine</li>
          <li>Choisir entre filtre à sable, cartouche ou diatomées</li>
          <li>Vérifier la qualité de la pompe</li>
        </ul>
      </section>

      <section>
        <h2>Quel système de traitement de l'eau choisir ?</h2>
        <p>Pour garder un eau saine,plusieurs solutions existent : </p>
        <ul>
          <li>Chlore : solution classique et efficace</li>
          <li>Brome : moins irritant pour la peau</li>
          <li>Électrolyse au sel : solution moderne et confortable</li>
          <li>UV ou ozone : traitement écologique</li>
        </ul>
      </section>

      <section>
        <h2>Quels accessoires sont indispensables ?</h2>
        <p>Pour un bon entretien de la piscine : </p>
        <ul>
          <li>Robot nettoyeur</li>
          <li>Épuisette et brosse</li>
          <li>Thermomètre</li>
          <li>Couverture de protection</li>
        </ul>
      </section>

      <section>
        <h2>Comment choisir l'éclairage de piscine ?</h2>
        <p>L'éclairage améliore a la fois l'esthétique et la sécurité : </p>
        <ul>
          <li>LED économiques et durables</li>
          <li>Projecteurs subaquatiques</li>
          <li>Éclairage multicolore pour ambiance</li>
        </ul>
      </section>

      <section>
        <h2>Comment assurer la sécurité de la piscine ?</h2>
        <p>La sécurité est obligatoire : </p>
        <ul>
          <li>Barrières de protection</li>
          <li>Alarmes de piscine</li>
          <li>Couvertures de sécurité</li>
          <li>Escaliers antidérapants</li>
        </ul>
      </section>

      <section>
        <p>
          Optimisez votre installation et gardez votre bassin propre et sûr :
          <a href="https://www.a2s-sarl.com" target="_blank" rel="noopener noreferrer">www.a2s-sarl.com</a>
          pour un accompagnement personnalisé.
        </p>
      </section>
    `,
    excerpt: "Améliorez l'efficacité énergétique de vos installations CVC pour réaliser des économies significatives et contribuer à la transition écologique.",
    featuredImage: "/images/blog/optimisation.jpeg",
    status: "published",
    authorId: 1,
    createdAt: "2024-02-15T10:00:00Z",
    updatedAt: "2024-02-15T10:00:00Z",
  },

  {
    id: 4,
    title: "De l'ancien au moderne : rénovation des bâtiments industriels et habitations",
    slug: "renovation",
    content: `
      <section>
        <h2>De l'ancien au moderne : rénovation des bâtiments industriels et habitations</h2>
        <p>
          La rénovation des bâtiments industriels et des habitations permet de valoriser les structures existantes
          tout en améliorant le confort, la sécurité et la performance énergétique.
        </p>
      </section>

      <section>
        <h2>Pourquoi rénover un bâtiment ancien ?</h2>
        <p> La rénovation permet de : </p>
        <ul>
          <li>Moderniser les infrastructures</li>
          <li>Améliorer la sécurité des bâtiments</li>
          <li>Réduire la consommation énergétique</li>
          <li>Augmenter la valeur du bien</li>
        </ul>
      </section>

      <section>
        <h2>Quelles sont les étapes de la rénovation ?</h2>
        <p>La rénovation d'un bâtiment suit plusieurs étapes : </p>
        <ul>
          <li>Diagnostic du bâtiment : état général de la structure</li>
          <li>Planification des travaux : choix des matériaux et des solutions</li>
          <li>Démolition partielle : suppression des éléments vétustes</li>
          <li>Travaux de gros ouvre : structure, murs, toiture</li>
          <li>Travaux de finition : électricité, peinture, aménagement</li>
        </ul>
      </section>

      <section>
        <h2>Comment moderniser un bâtiment industriel ?</h2>
        <p>Pour les bâtiments industriels,la rénovation peut inclure : </p>
        <ul>
          <li>Renforcement de la structure</li>
          <li>Optimisation des espaces de travail</li>
          <li>Mise aux normes de sécurité</li>
          <li>Amélioration de l'isolation thermique</li>
          <li>Installation d'équipements modernes</li>
        </ul>
      </section>

      <section>
        <h2>Comment rénover une habitation ancienne ?</h2>
        <p>Pour les maisons et habitations : </p>
        <ul>
          <li>Rénovation de la cuisine et salle de bain</li>
          <li>Isolation thermique et phonique</li>
          <li>Changement des installations électriques</li>
          <li>Modernisation du design intérieur</li>
        </ul>
      </section>

      <section>
        <h2>Quels matériaux utiliser pour une rénovation moderne ?</h2>
        <p>Les matériaux modernes les plus utilisés :</p>
        <ul>
          <li>Béton renforcé</li>
          <li>Acier pour la structure</li>
          <li>Bois pour l'esthétique</li>
          <li>Matériaux isolants écologiques</li>
        </ul>
      </section>

      <section>
        <h2>Quels sont les avantages de la rénovation ?</h2>
        <ul>
          <li>Réduction des coûts par rapport au neuf</li>
          <li>Valorisation du patrimoine immobilier</li>
          <li>Amélioration du confort</li>
          <li>Respect de l'environnement</li>
        </ul>
      </section>

      <section>
        <p>
          Transformez vos bâtiments anciens en espaces modernes et fonctionnels :
          <a href="https://www.a2s-sarl.com" target="_blank" rel="noopener noreferrer">www.a2s-sarl.com</a>
          dès maintenant pour un accompagnement complet en rénovation.
        </p>
      </section>
    `,
    excerpt: "Assurez la santé de vos employés et la conformité réglementaire grâce à des solutions de filtration et de ventilation adaptées.",
    featuredImage: "/images/blog/ancien.jpeg",
    status: "published",
    authorId: 1,
    createdAt: "2024-03-01T10:00:00Z",
    updatedAt: "2024-03-01T10:00:00Z",
  },

  {
    id: 5,
    title: "Fournitures industrielles : solutions adaptées aux besoins des entreprises",
    slug: "industrial-supply",
    content: `
      <section>
        <h2>Fournitures industrielles : solutions adaptées aux besoins des entreprises </h2>
        <p>
          Les fournitures industrielles regroupent l'ensemble des équipements, outils et consommables utilisés dans les entreprises
          pour la production, la maintenance et l'exploitation.
          Elles sont essentielles au bon fonctionnement de l'activité industrielle.
        </p>
      </section>

      <section>
        <h2>Pourquoi les fournitures industrielles sont importantes ?</h2>
        <p>Elles permettent de : </p>
        <ul>
          <li>Assurer la continuité de la production</li>
          <li>Améliorer la performance des machines</li>
          <li>Réduire les pannes et arrêts</li>
          <li>Optimiser les coûts de maintenance</li>
        </ul>
      </section>

      <section>
        <h2>Quels sont les types de fournitures industrielles ?</h2>
        <p>On peut les classer en plusieurs catégories :</p>
        <ul>
          <li>Équipements de production</li>
          <li>Outils de maintenance</li>
          <li>Pièces de rechange</li>
          <li>Consommables industriels</li>
          <li>Équipements de sécurité</li>
        </ul>
      </section>

      <section>
        <h2>Comment choisir des fournitures industrielles de qualité ?</h2>
        <p>Pour bien choisir,il faut prendre en compte :</p>
        <ul>
          <li>La qualité des matériaux</li>
          <li>La fiabilité du fournisseur</li>
          <li>La compatibilité avec les machines</li>
          <li>Le rapport qualité/prix</li>
          <li>La disponibilité des pièces</li>
        </ul>
      </section>

      <section>
        <h2>Où trouver des fournitures industrielles fiables ?</h2>
        <p>Les entreprises peuvent s'approvisionner auprès de :</p> 
        <ul>
          <li>Fournisseurs spécialisés</li>
          <li>Distributeurs industriels</li>
          <li>Plateformes professionnelles en ligne</li>
        </ul>
      </section>

      <section>
        <h2>Quels sont les avantages de bonnes fournitures industrielles ?</h2>
        <ul>
          <li>Meilleure productivité</li>
          <li>Réduction des pannes</li>
          <li>Optimisation des coûts</li>
          <li>Longévité des équipements</li>
        </ul>
      </section>

      <section>
        <p>
          Trouvez des fournitures industrielles fiables et adaptées à vos besoins :
          <a href="https://www.a2s-sarl.com" target="_blank" rel="noopener noreferrer">www.a2s-sarl.com</a>
          dès maintenant pour une solution sur mesure pour votre entreprise.
        </p>
      </section>
    `,
    excerpt: "Découvrez les systèmes de réfrigération adaptés aux besoins industriels, garantissant précision et fiabilité dans tous les secteurs.",
    featuredImage: "/images/blog/fournitures.jpeg",
    status: "published",
    authorId: 1,
    createdAt: "2024-03-15T10:00:00Z",
    updatedAt: "2024-03-15T10:00:00Z",
  },

  {
    id: 6,
    title: "Compresseurs d'air : types, fonctionnement et applications industrielles",
    slug: "air-compressors",
    content: `
      <section>
        <h2>Compresseurs d'air : types, fonctionnement et applications industrielles</h2>
        <p>
          Les compresseurs d'air sont des équipements essentiels dans l'industrie, utilisés pour alimenter différents outils et machines.
          Voici un guide complet pour comprendre leur fonctionnement et leurs applications.
        </p>
      </section>

      <section>
        <h2>Comment fonctionne un compresseur d'air ?</h2>
        <p>Le fonctionnement est simple : </p>
        <ul>
          <li>L'air est aspiré de l'extérieur</li>
          <li>Il est comprimé dans un réservoir</li>
          <li>La pression augmente</li>
          <li>L'air est ensuite libéré selon les besoins</li>
        </ul>
      </section>

      <section>
        <h2>Quels sont les types de compresseurs d'air ?</h2>
        <p>Il existe plusieurs types principaux : </p>
        <ul>
          <li>Compresseur à piston : le plus courant, utilisé dans les ateliers</li>
          <li>Compresseur à vis : utilisé dans l'industrie pour un usage continu</li>
          <li>Compresseur centrifuge : adapté aux grandes installations industrielles</li>
          <li>Compresseur portable : utilisé pour les petits travaux</li>
        </ul>
      </section>

      <section>
        <h2>Quelles sont les applications industrielles ?</h2>
        <p>Les compresseurs d'air sont utilisés dans plusieurs secteurs :</p>
        <ul>
          <li>Industrie manufacturière</li>
          <li>BTP (construction)</li>
          <li>Automobile</li>
          <li>Maintenance industrielle</li>
          <li>Agroalimentaire</li>
        </ul>
      </section>

      <section>
        <h2>Comment choisir un compresseur d'air ?</h2>
        <p>Pour bien choisir,il faut considérer : </p>
        <ul>
          <li>La puissance nécessaire</li>
          <li>Le débit d'air</li>
          <li>La pression requise</li>
          <li>Le type d'utilisation (occasionnelle ou continue)</li>
          <li>La consommation énergétique</li>
        </ul>
      </section>

      <section>
        <h2>Comment entretenir un compresseur d'air ?</h2>
        <p>Un bon entretien permet d'augmantrer la durée de vie : </p>
        <ul>
          <li>Vérifier régulièrement le niveau d'huile</li>
          <li>Nettoyer les filtres</li>
          <li>Contrôler la pression</li>
          <li>Purger le réservoir</li>
        </ul>
      </section>

      <section>
        <p>
          Améliorez la performance de vos équipements avec des compresseurs d'air adaptés à vos besoins :
          <a href="https://www.a2s-sarl.com" target="_blank" rel="noopener noreferrer">www.a2s-sarl.com</a>
          dès maintenant pour un conseil ou un devis personnalisé.
        </p>
      </section>
    `,
    excerpt: "Renouvelez vos installations CVC obsolètes pour bénéficier de technologies modernes, réduire vos coûts énergétiques et améliorer vos performances.",
    featuredImage: "/images/blog/modernisation.jpeg",
    status: "published",
    authorId: 1,
    createdAt: "2024-04-01T10:00:00Z",
    updatedAt: "2024-04-01T10:00:00Z",
  },

  {
    id: 7,
    title: "GMAO : la clé pour maintenance industrielle efficace",
    slug: "maintenance-gmao",
    content: `
      <section>
        <h2>GMAO : la clé pour une maintenance industrielle efficace</h2>
        <p>
          La GMAO (Gestion de Maintenance Assistée par Ordinateur) est devenue un outil essentiel pour les entreprises industrielles modernes.
          Elle permet de digitaliser et d'optimiser toutes les opérations de maintenance.
        </p>
      </section>

      <section>
        <h2>Comment fonctionne un logiciel GMAO ?</h2>
        <p>Un système GMAO fonctionne de manière simple : </p>
        <ul>
          <li>Enregistrement des équipements</li>
          <li>Planification des interventions</li>
          <li>Suivi des pannes et réparations</li>
          <li>Analyse des performances</li>
        </ul>
      </section>

      <section>
        <h2>Pourquoi utiliser la GMAO en entreprise ?</h2>
        <p>La GMAO permet de :</p>
        <ul>
          <li>Réduire les pannes</li>
          <li>Améliorer la disponibilité des machines</li>
          <li>Organiser les interventions</li>
          <li>Réduire les coûts de maintenance</li>
        </ul>
      </section>

      <section>
        <h2>Quels sont les avantages de la GMAO ?</h2>
        <ul>
          <li>Meilleure organisation de la maintenance</li>
          <li>Gain de temps pour les techniciens</li>
          <li>Historique complet des équipements</li>
          <li>Amélioration de la productivité</li>
          <li>Réduction des arrêts de production</li>
        </ul>
      </section>

      <section>
        <h2>Dans quels secteurs utilise-t-on la GMAO ?</h2>
        <p>La GMAO est utilisée dans plusieurs domaines :</p>
        <ul>
          <li>Industrie manufacturière</li>
          <li>Énergie</li>
          <li>BTP</li>
          <li>Agroalimentaire</li>
          <li>Hôpitaux et services techniques</li>
        </ul>
      </section>

      <section>
        <h2>Comment choisir un logiciel GMAO ?</h2>
        <p>Pour bien choisir,il faut vérifier :</p>
        <ul>
          <li>La simplicité d'utilisation</li>
          <li>Les fonctionnalités proposées</li>
          <li>La compatibilité avec l'entreprise</li>
          <li>Le support technique</li>
          <li>Le coût</li>
        </ul>
      </section>

      <section>
        <p>
          Adoptez une GMAO performante pour piloter votre maintenance industrielle de manière efficace :
          <a href="https://www.a2s-sarl.com" target="_blank" rel="noopener noreferrer">www.a2s-sarl.com</a>
          dès maintenant.
        </p>
      </section>
    `,
    excerpt: "En cas de panne, notre équipe d'experts intervient en urgence pour réparer vos systèmes CVC et restaurer rapidement vos conditions de travail.",
    featuredImage: "/images/blog/gmao.jpeg",
    status: "published",
    authorId: 1,
    createdAt: "2024-04-15T10:00:00Z",
    updatedAt: "2024-04-15T10:00:00Z",
  },

  {
    id: 8,
    title: "Travaux d’électricité : installation, dépannage et normes électriques",
    slug: "electrical-works",
    content: `
      <section>
        <h2>Travaux d’électricité : installation, dépannage et normes électriques</h2>
        <p>
        Comment réaliser des travaux d’électricité en toute sécurité ? Quelles sont les normes à respecter pour une installation fiable ?
        Les travaux d’électricité sont essentiels dans tout bâtiment, que ce soit pour une installation neuve, une rénovation ou un dépannage. Voici un guide complet pour mieux comprendre.        </p>
      </section>

      <section>
        <h2> Qu’est-ce que les travaux d’électricité ?</h2>
        <p>Les travaux d’électricité regroupent toutes les opérations liées à :</p>
        <ul>
          <li>L’installation électrique</li>
          <li>La maintenance</li>
          <li>Le dépannage</li>
          <li>La mise aux normes</li>
        </ul>
      </section>

       <section>
        <h2> Quels sont les types de travaux d’électricité ?</h2>
        <p>On distingue plusieurs types :</p>
        <ul>
          <li>Installation électrique : câblage, prises, éclairage</li>
          <li>Dépannage électrique : réparation des pannes</li>
          <li>Maintenance électrique : contrôle et entretien</li>
          <li>Mise aux normes : conformité aux règles de sécurité</li>
        </ul>
      </section>

      <section>
        <h2> Comment fonctionne une installation électrique ?</h2>
        <p>Une installation électrique comprend :</p>
        <ul>
          <li>Un tableau électrique</li>
          <li>Des câbles et circuits</li>
          <li>Des prises et interrupteurs</li>
          <li>Des dispositifs de protection</li>
        </ul>
      </section>
      <section>
        <h2>  Pourquoi le dépannage électrique est important ?</h2>
        <p>Le dépannage permet de résoudre les problèmes tels que :</p>
        <ul>
          <li>Coupures de courant</li>
          <li>Court-circuit</li>
          <li>Pannes d’appareils</li>
          <li>Problèmes de câblage</li>
        </ul>
      </section>
       <section>
        <h2> Quelles sont les normes électriques à respecter ?</h2>
        <p>Les installations électriques doivent respecter des normes strictes :</p>
        <ul>
          <li>Sécurité des personnes</li>
          <li>Protection contre les courts-circuits</li>
          <li>Qualité des équipements</li>
          <li>Conformité des installations</li>
        </ul>
      </section>
       <section>
        <h2>Comment réaliser des travaux d’électricité en sécurité ?</h2>
        <p>Pour travailler en sécurité :</p>
        <ul>
          <li>Couper le courant avant intervention</li>
          <li>Utiliser des outils adaptés</li>
          <li>Respecter les normes électriques</li>
          <li>Faire appel à des professionnels qualifiés</li>
        </ul>
      </section>
      <section>
        <p>
          Assurez la sécurité et la conformité de vos installations électriques : contactez 
          <a href="https://www.a2s-sarl.com" target="_blank" rel="noopener noreferrer">www.a2s-sarl.com</a>
          dès maintenant pour vos travaux d’électricité, installation ou dépannage.
        </p>
      </section>
    `,
    excerpt: "Travaux d’électricité est essentiel pour assurer la sécurité et le bon fonctionnement des installations dans les bâtiments industriels et résidentiels.",
    featuredImage: "/images/blog/travaux.jpeg",
    status: "published",
    authorId: 1,
    createdAt: "2024-05-01T10:00:00Z",
    updatedAt: "2024-05-01T10:00:00Z",
  },
];


// Helper function to get a blog post by ID
export const getBlogPostById = (id: number): Post | undefined => {
  return blogPosts.find(post => post.id === id);
};

// Helper function to get a blog post by slug
export const getBlogPostBySlug = (slug: string): Post | undefined => {
  const legacySlugMap: Record<string, string> = {
    'maintenance-industrielle': 'maintenance',
    'traitement-des-eaux-usées-et-assainissement': 'water-treatment',
    'équipements-de-piscines': 'pools',
    'de-ancien-au-moderne': 'renovation',
    'fournitures-industrielles': 'industrial-supply',
    'compresseurs-air': 'air-compressors',
    'travaux-électricité': 'electrical-works'
  };
  const requestedSlug = slug.trim().toLowerCase();
  const normalizedSlug = legacySlugMap[requestedSlug] || requestedSlug;
  return blogPosts.find(post => post.slug.trim().toLowerCase() === normalizedSlug);
};

// Helper function to get all published blog posts
export const getPublishedBlogPosts = (): Post[] => {
  return blogPosts.filter(post => post.status === 'published');
};
